import { VideoRepresentation } from '../types';

export const getVideoPrivacyVisibilityValue = (video: VideoRepresentation) =>
  video.privacy_settings?.visibility || 'public';
